import {
  USER_LOADING,
  USER_SUCCESS,
  USER_FAILED,
  USER_UPDATE_LOADING,
  USER_UPDATE_SUCCESS,
  USER_UPDATE_FAILED,

  UPDATE_BANKING_LOADING,
  UPDATE_BANKING_SUCCESS,
  UPDATE_BANKING_FAILED,

  RESET_SNACK
} from '../actions/userProfileActions.js'

const UserProfile = (state = {
  isFetching: false,
  error: null,
  questions: [],
  dataSent: {},
  success: false,
  user: null
}, action) => {
  switch (action.type) {
    case USER_LOADING:
      return Object.assign({}, state, {
        isFetching: true,
        user: null,
        error: null
      })
    case USER_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        user: action.response,
        error: null
      })
    case USER_FAILED:
      return Object.assign({}, state, {
        isFetching: false,
        user: null,
        error: action.error
      })
    case USER_UPDATE_LOADING:
      return Object.assign({}, state, {
        isFetching: true,
        success: null,
        error: null
      })
    case USER_UPDATE_SUCCESS:
      // not sure if it should be done like this but we need to update the email
      // that is in the current state so the UI updates, setting the new user class breaks things
      state.user.email = action.response.email
      return Object.assign({}, state, {
        userResponse: action.response,
        isFetching: false,
        success: true,
        error: null
      })
    case USER_UPDATE_FAILED:
      return Object.assign({}, state, {
        isFetching: false,
        error: action.error,
        success: false
      })

    case UPDATE_BANKING_LOADING:
      return Object.assign({}, state, {
        loading: true,
        bankingSuccess: null,
        error: null
      })
    case UPDATE_BANKING_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        bankingSuccess: action.response,
        error: null
      })
    case UPDATE_BANKING_FAILED:
      return Object.assign({}, state, {
        loading: false,
        bankingSuccess: null,
        error: action.error
      })
    case RESET_SNACK:
      return Object.assign({}, state, {
        success: false,
        error: null
      })
    default:
      return state
  }
}

export default UserProfile



// WEBPACK FOOTER //
// ./src/redux/reducers/userProfileReducer.js